// removed by extract-text-webpack-plugin
module.exports = {"linkWrapper":"Gbcecca","orderDetailsItem":"G1afc89","message":"Gf341a1"};